import styled, { css } from 'styled-components';
import {
    BORDER_RADIUS,
    Component,
    Decision,
    getComponentVariableToken,
    NestedCardVariant,
    SPACING,
} from '@optimus-web/local-tokens';
import theme from '@optimus-web/theme';
import { CardSpacing } from '../Card/cardSpacing';
import { Attachment, getAttachmentBorderRadius } from '../utils/attachment';

const getNestedCardToken = getComponentVariableToken(Component.NestedCard, 'variant');

interface NestedCardProps {
    variant?: NestedCardVariant;
    padding?: CardSpacing;
    attachment?: Attachment;
    fill?: boolean;
    overflowHidden?: boolean;
}

const NestedCard = styled.div<NestedCardProps>`
    box-sizing: border-box;
    ${(props) => `border-radius: ${getAttachmentBorderRadius(props.attachment, BORDER_RADIUS[50])};`}
    background-color: ${getNestedCardToken(Decision.BackgroundColor)};
    ${(props) => props.padding && `padding: ${SPACING[props.padding]}px;`}
    ${(props) => props.variant === 'default' && `border: 1px solid ${getNestedCardToken(Decision.BorderColor)(props)};`}
    ${(props) => props.overflowHidden === true && `overflow: hidden;`}
    ${(props) =>
        (props.variant === 'emphasized' || props.variant === 'highlighted') &&
        css`
            border: 1px solid transparent;
        `}
    ${(props) =>
        props.fill === true &&
        css`
            height: 100%;
        `}
`;

NestedCard.defaultProps = {
    variant: 'default',
    padding: '200',
    theme,
};

export default NestedCard;
